import { Controller } from 'stimulus'
import { debounce } from 'lodash'

export default class FormulaSearchController extends Controller {
  static targets = []

  search = debounce(async (evt) => {
    const res = await fetch(`/formulas?search=${evt.target.value}`)
    const response = await res.text()

    const parser = new window.DOMParser(response)
    const doc = parser.parseFromString(response, 'text/html')
    const table = doc.querySelector('.formulas-table')

    document.querySelector('.formulas-table').innerHTML = table.innerHTML
  }, 300)
}
